module.exports = __webpack_public_path__ + "img/fast_code_ad.a1788c56.jpg";